/**
 * Counts clicks on game plan emails (APS-259 step 4), whatever page the
 * link opens. Mounted once inside the router. Tracks after sign-in, once per
 * link per tab.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import analytics from '../../services/analytics';
import { emailClickTopic } from './gamePlanLinks';

const SEEN_KEY = 'gamePlanEmailClicks';

function alreadyTracked(link: string): boolean {
  try {
    const seen: string[] = JSON.parse(sessionStorage.getItem(SEEN_KEY) || '[]');
    if (seen.includes(link)) return true;
    sessionStorage.setItem(SEEN_KEY, JSON.stringify([...seen, link].slice(-20)));
  } catch { /* storage off: track anyway */ }
  return false;
}

const GamePlanEmailClickTracker: React.FC = () => {
  const { pathname, search } = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    const click = emailClickTopic(pathname, search);
    if (!click || alreadyTracked(pathname + search)) return;
    try { analytics.track('game_plan_email_clicked', click); } catch {}
  }, [pathname, search, user]);

  return null;
};

export default GamePlanEmailClickTracker;
